import styled from 'styled-components';
import type { TransitionProps } from 'view/styles/transitions';
import { fadeInOut, speedMs } from 'view/styles/transitions';
import { SearchResultError } from '../error';
import { SearchResultSome } from '../some';
import { SearchResultNone } from '../none';
import { SearchResultLoading } from '../loading';

export const MODAL_FADE_TRANSITION_MS = speedMs.medium;

export const Container = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    /* Enables smooth scrolling on mobile devices (chrome/safari) */
    -webkit-overflow-scrolling: touch;
`;

export const ResultLoading = styled(SearchResultLoading)<TransitionProps>`
    ${fadeInOut(MODAL_FADE_TRANSITION_MS)};
`;

export const ResultSome = styled(SearchResultSome)<TransitionProps>`
    ${fadeInOut(MODAL_FADE_TRANSITION_MS)};
`;

export const ResultNone = styled(SearchResultNone)<TransitionProps>`
    ${fadeInOut(MODAL_FADE_TRANSITION_MS)};
`;

export const ResultError = styled(SearchResultError)<TransitionProps>`
    ${fadeInOut(MODAL_FADE_TRANSITION_MS)};
`;
